import React from 'react'
import './payment-record.less'
import { setHeader } from '@/util/set-header'
import { fetchCheckinBase,resetNetPassword } from '@/api/payment'
import { connect } from 'react-redux'
import { Toast } from 'antd-mobile'
import { withRouter } from 'react-router'
import * as util from '@/util/util'
const mapStateToProps = (state: any) => {
  return {
    info: state.payment,
  }
}
@(connect(mapStateToProps) as any)
@(withRouter as any)
class PaymentRecord extends React.Component<any, any> {
  keyPath: any = {
    '13001': 'bed-icon', //房费
    '13014': 'heating-icon', //暖气费
    '13013': 'air-conditioning-icon', //中央空调费
    '13004': 'cold_water_fee-icon', //冷水费
    '13005': 'hot_water_fee-icon', //热水费
    '12001': 'electric-icon', //电费
    '13002': 'deposit-icon', //押金
    '13008': 'network-icon', //网络费
  }
  keyColor: any = {
    '13001': '#15B6B1', //房费
    '13014': '#C89829', //暖气费
    '13013': '#46B6B0', //中央空调费
    '13004': '#019FE6', //冷水费
    '13005': '#4489CA', //热水费
    '12001': '#E3004F', //电费
    '13002': '#8AC897', //押金
    '13008': '#23AC3A', //网络费
  }
  constructor(props: any) {
    super(props)
    this.state = {
      info: '',
    }
    this.leftClick = this.leftClick.bind(this)
    this.navPayRecord = this.navPayRecord.bind(this)
    this.feachData = this.feachData.bind(this)
    this.navPay = this.navPay.bind(this)
    this.navRecordList = this.navRecordList.bind(this)
  }
  UNSAFE_componentWillMount() {
    setHeader({
      title: '',
      leftClick: this.leftClick,
      className: 'payment-record-nav',
    })
  }
  async componentDidMount() {
    const { info } = this.props
    if (info.checkin_id) {
      this.feachData(info.checkin_id)
    }
  }
  async componentWillReceiveProps(nextProps: any) {
    const nextInfo = nextProps.info
    const { info } = this.props
    if (nextInfo.checkin_id === '' || nextInfo.checkin_id === undefined) {
      Toast.info('您当前可能还未入住，请入住后在缴费哦~', 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    if (info.checkin_id !== nextInfo.checkin_id) {
      this.feachData(nextInfo.checkin_id)
    }
  }

  async feachData(checkin_id:any){
    Toast.loading('加载中', 0)
    const { data } = await fetchCheckinBase(checkin_id)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2, () => {
        if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
      })
      return
    }
    setHeader({
      title: data.data.info.store_no,
      leftClick: this.leftClick,
      className: 'payment-record-nav',
    })
    const infoObj = data.data
    this.setState({
      ...infoObj,
    })
  }
  leftClick() {
    //返回App
    if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
  }
  navPayRecord(){
    this.props.history.push({pathname:`/payment/bill/1`,state:{from:"payment-record"}})
  }
  //查看记录
  navRecordList(item:any){
    if(item.subject_id==='13001'||item.subject_id==='13004'||item.subject_id==='13005'){
      this.props.history.push({pathname:`/payment/complex-list`,state:{...item}})
    }else{
      
      this.props.history.push({pathname:`/payment/basic-list`,state:{...item}})
    }
  
  }
  //去缴费
  navPay(item:any){
    if(item.subject_id==='13004'&&item.abnormal){
      Toast.info('您当前无需缴纳冷水费', 3)
      return
    }
   
    switch (item.subject_id){
        case '13001':
            this.props.history.push(`/payment/bed`)
        break;
        case '13014':
            this.props.history.push(`/payment/heating`)
        break;
        case '13013':
            this.props.history.push(`/payment/airconditioner`)
        break;
        case '13004':
            this.props.history.push(`/payment/cold-water`)
        break;
        case '13005':
            this.props.history.push(`/payment/hot-water`)
        break;
        case '12001':
            this.props.history.push(`/payment/electric`)
        break;
        case '13008':
            this.props.history.push(`/payment/networkFee`)
        break;
    }
  }
  //重置网络密码
  async resetPass(e:any){
    e.stopPropagation();
    const { info } = this.props
    if (info.checkin_id) {
      Toast.loading('加载中', 0)
      const { data } = await resetNetPassword(info.checkin_id)
      Toast.hide()
      if (data.code !== 'SUCCESS') {
        Toast.info(data.msg, 2)
        return
      }else{
        Toast.info('密码已更改，请等待短信', 2)
      }
    }

  }
  render() {
    
    let { info,air_conditioner,cold_water_fee,electric,heating,hot_water_fee,internet,roomfee } = this.state
    let  subItems 
    if(roomfee&&cold_water_fee&&hot_water_fee&&heating&&air_conditioner&&internet&&electric){
      roomfee={...roomfee,title:'床位余额'}
      internet={...internet,title:'床位缴费'}
      electric.subject_name='电费'
      electric={...electric,title:'房间消费'}
      const list=[roomfee,cold_water_fee,hot_water_fee,heating,air_conditioner,internet,electric]
  
      subItems= list.map((item: any, index: number) => {
        if(!(item.is_show===false)){
          return (
            <div className="pay-record-item" key={index}>
              <div>{item.title}</div>
              <div>
                <div className='pay-record-text' style={{color:item.is_qianfei?this.keyColor[item.subject_id]:'#000'}} onClick={()=>this.navRecordList(item)}>
                  <p className='font-8' style={{color:'#000'}}>{item.is_intelligence ? '房间公用电量剩余': item.subject_name} {item.is_qianfei&&<span className='is-qian-fei font-8' style={{background:this.keyColor[item.subject_id]}}>欠费</span>}</p>
                  {item.subject_id === '12001' 
                  ? <p className='font-2'>{item.is_intelligence?`${util.toDecimal2(item.meter_balance)}度`:`${util.toDecimal2(item.balance)}元`}</p>
                  : <p className='font-2'>{item.is_qianfei?`-${util.toDecimal2(item.qianfei)}`:util.toDecimal2(item.balance)}元</p>}
                  <p className='font-8'>{item.text} {item.subject_id==='13008'&&item.is_auth&&<span className='pay-reset' onClick={this.resetPass.bind(this)}>重置密码</span>}</p>
                </div>
                <div className='pay-record-icon' style={{background:this.keyColor[item.subject_id]}} onClick={()=>this.navPay(item)}>
                <img
                    src={`/public/assets/img/${
                      this.keyPath[item.subject_id]
                    }.png`}  alt=''/>
                  <p className='font-6'>{`${item.subject_name.length<4?'充':''}${item.subject_name}`}</p>
                </div>
              </div>
            </div>
            )
        }
        return ''
 
      })
    }

    return (
      <div className="payment-record">
        <div className="pay-bed-info">
          <div className="font-1">
            {info.room_no} &nbsp;&nbsp;{info.bed_no}
          </div>
          <p>
            入住周期：{info.start_day} 至 {info.end_day}
          </p>
          <div className="pay-re-list font-6" onClick={this.navPayRecord}>缴费记录</div>
        </div>
        <div className="pay-record-info">
            {subItems}
        </div>
      </div>
    )
  }
}

export default PaymentRecord
